import Cookies from 'js-cookie/src/js.cookie';

export default {
  set(name, value, minutes) {
    Cookies.set(name, value, { expires: minutes / 60 / 24 });
  },

  get(name) {
    return Cookies.get(name);
  },
};
